export class UiUtils {
  static blur() {
    const activeElement = document.activeElement;
    if (activeElement instanceof HTMLElement) {
      activeElement.blur();
    }
  }

  static focusElement(
    target: string,
    hotkey: string,
    cb?: () => void,
  ): () => void {
    const hotkeyEventHandler = (e: KeyboardEvent): void => {
      const currentFocus = document.activeElement;
      if (
        e.key !== hotkey ||
        currentFocus?.matches(target) ||
        currentFocus?.tagName === "INPUT"
      ) {
        return;
      }

      const targetElement = document.querySelector(target) as HTMLElement;
      targetElement?.focus();
      e.preventDefault();
      cb && cb();
    };
    document.addEventListener("keydown", hotkeyEventHandler);
    return (): void =>
      document.removeEventListener("keydown", hotkeyEventHandler);
  }

  static cmdHotKeyElement(target: string, cb: () => void): () => void {
    const hotkeyEventHandler = (e: KeyboardEvent): void => {
      if (e.keyCode === 75 && (e.metaKey || e.ctrlKey)) {
        const targetElement = document.querySelector(target) as HTMLElement;
        targetElement?.click();
        e.preventDefault();
        cb && cb();
      }
    };
    document.addEventListener("keydown", hotkeyEventHandler);
    return (): void =>
      document.removeEventListener("keydown", hotkeyEventHandler);
  }
}
